import React, { useState } from "react";
import { NameBroadcastForm } from "../components/name-broadcast-form";
import { BroadcastActionsForm } from "../components/broadcast-actions-form";
import { ContactFilesForm } from "../components/contact-files-form";
import { ScheduleBroadcastForm } from "../components/schedule-broadcast-form";
import { ResumeBroadcast } from "../components/resume-broadcast";
import { BroadcastSuccess } from "../components/broadcast-success";
import { WhatsAppNotificationForm } from "../components/whatsapp-notification-form";
import { TagContactsForm } from "../components/tag-contacts-form";
import { TemplateStep } from "../components/template-step";

const BroadcastSelectFileView = () => {
  const [step, setStep] = useState(0);
  const [broadcastData, setBroadcastData] = useState({});

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    // Last step
    if (step === 8) {
      return;
    }

    setStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  const handleBackSkip = () => {
    // Last step
    if (step === 8) {
      return;
    }

    setStep((prevStep) => Math.max(prevStep - 2, 0));
  };

  const updateBroadcastData = (data) => {
    setBroadcastData((prev) => ({ ...prev, ...data }));
  };

  const handleReset = () => {
    setBroadcastData({});
    setStep(0);
  };

  const handleSkip = () => {
    setStep((prevStep) => prevStep + 2);
  };

  return (
    <>
      {step === 0 && (
        <NameBroadcastForm
          handleNext={handleNext}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
        />
      )}

      {step === 1 && (
        <TemplateStep
          handleNext={handleNext}
          handleBack={handleBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
          handleSkip={handleSkip}
        />
      )}

      {step === 2 && (
        <BroadcastActionsForm
          handleNext={handleNext}
          handleBack={handleBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
        />
      )}

      {step === 3 && (
        <ContactFilesForm
          handleNext={handleNext}
          handleBack={handleBack}
          handleBackSkip={handleBackSkip}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
        />
      )}

      {step === 4 && (
        <ScheduleBroadcastForm
          handleNext={handleNext}
          handleBack={handleBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
        />
      )}

      {step === 5 && (
        <WhatsAppNotificationForm
          handleNext={handleNext}
          handleBack={handleBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
        />
      )}

      {step === 6 && (
        <TagContactsForm
          handleNext={handleNext}
          handleBack={handleBack}
          updateBroadcastData={updateBroadcastData}
          broadcastData={broadcastData}
        />
      )}

      {step === 7 && (
        <ResumeBroadcast
          handleNext={handleNext}
          handleBack={handleBack}
          broadcastData={broadcastData}
        />
      )}

      {step === 8 && (
        <BroadcastSuccess
          broadcastData={broadcastData}
          handleReset={handleReset}
        />
      )}
    </>
  );
};

export default BroadcastSelectFileView;
